'use client'
import React from 'react'
import Image from 'next/image'
import { components } from 'react-select'

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <Image
        src="/img/icons/dropdownSecondaryArrow.svg"
        width={16}
        height={16}
        alt="arrow"
      />
    </components.DropdownIndicator>
  )
}

export default DropdownIndicator
